import { usePage } from "../hooks/CmsHooks";
import CockpitLayoutComponents from "../components/CockpitLayoutComponents";
import DocumentTitle from "../functional-components/DocumentTitle";
import RobotsNoindex from "../components/RobotsNoindex";
import PrerenderStatus from "../components/PrerenderStatus";

const PageNotFoundFragment = () => {
  const page = usePage("/404");
  return (
    <>
      <DocumentTitle title={page.title} />
      <PrerenderStatus code={404} />
      <RobotsNoindex />
      <CockpitLayoutComponents components={page.content} />
    </>
  );
};

export default PageNotFoundFragment;
